import type { Migration } from './types';

export function createMigration({
    migrateVideo,
    migrateTemplate = (template) => template,
    migrateSceneGroup = (sceneGroup) => sceneGroup,
    migrateScene = (scene) => scene,
}: Migration): Migration {
    return {
        migrateVideo,
        migrateTemplate,
        migrateSceneGroup,
        migrateScene,
    };
}
